import { createFileRoute } from "@tanstack/react-router";
import { useTranslation } from "react-i18next";

import BackButton from "@/components/back-button";
import Button from "@/components/button";
import { MessagesIcon } from "@/components/icons";
import Input from "@/components/input";
import Textarea from "@/components/textarea";
import {
  Card,
  CardContent,
  CardFooter,
  CardHeader,
  CardTitle,
} from "@/components/ui/card";

export const Route = createFileRoute("/app/$role/_app/contact/")({
  component: RouteComponent,
});

function RouteComponent() {
  const { t } = useTranslation("dashboard");
  return (
    <div className="flex flex-col gap-5 w-full">
      <BackButton />
      <Card className="bg-white border-none max-w-[1440px]">
        <CardHeader>
          <CardTitle className="text-[20px] font-bold">
            {t("contact.title")}
          </CardTitle>
        </CardHeader>
        <CardContent className="max-w-[660px] flex flex-col gap-5">
          <div className="grid grid-cols-2 gap-4 ">
            <Input label={t("contact.firstName")} />
            <Input label={t("contact.lastName")} />
            <Input label={t("contact.email")} type="email" />
            <Input label={t("contact.phone")} />
          </div>
          <Textarea label={t("contact.describeProblem")} />
          <Button variant="secondary" size="lg" className="max-w-[320px]">
            {t("contact.submitRequest")}
          </Button>
        </CardContent>
        <CardFooter className=" max-w-[656px] mt-10 pb-[140px] flex flex-col items-start!">
          <div
            className="h-[1px] w-full mb-10"
            style={{ backgroundColor: "rgba(34, 10, 10, 0.25)" }}
          />
          <Button variant="outline" size="lg" className="w-[320px]">
            <MessagesIcon /> {t("contact.chatWithSupport")}
          </Button>
        </CardFooter>
      </Card>
    </div>
  );
}
